import { Outlet } from 'react-router-dom';
import { MarketplaceStoreProvider } from './contexts/MarketplaceStoreProvider';

/**
 * Root component for the Vite-based marketplace app.
 * MarketplaceStoreProvider loads config then nests:
 *   StoreProvider → AuthProvider → CartProvider
 */
export default function App() {
  return (
    <MarketplaceStoreProvider>
      <Outlet />
    </MarketplaceStoreProvider>
  );
}
